import { render, staticRenderFns } from "./ToBeImproved.vue?vue&type=template&id=2a0e5d98&"
import script from "./ToBeImproved.vue?vue&type=script&lang=js&"
export * from "./ToBeImproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports